import { watch } from 'vue'
import {
  SIDEBAR_COOKIE_OPTIONS,
  SUB_NAV_COLLAPSED_COOKIE,
  SUB_NAV_COLLAPSED_STORAGE_KEY,
  SUB_NAV_STATE_KEY,
} from '~/utils/dashboard-sidebar-state'

/** 仅客户端模块级守卫，避免 useState 把「已安装」序列化到 SSR payload 导致客户端不再初始化 */
let clientSyncInstalled = false

function parseCollapsedFlag(value) {
  const raw = typeof value === 'string' ? decodeURIComponent(value) : value
  if (raw === '1' || raw === 1 || raw === true) return true
  if (raw === '0' || raw === 0 || raw === false) return false
  return null
}

function readDocumentCookieCollapsed() {
  if (!import.meta.client) return null
  try {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${SUB_NAV_COLLAPSED_COOKIE}=([^;]*)`),
    )
    return match ? parseCollapsedFlag(match[1]) : null
  } catch {
    return null
  }
}

function readSessionCollapsed() {
  if (!import.meta.client) return null
  try {
    return parseCollapsedFlag(sessionStorage.getItem(SUB_NAV_COLLAPSED_STORAGE_KEY))
  } catch {
    return null
  }
}

function writeSessionCollapsed(collapsed) {
  if (!import.meta.client) return
  try {
    sessionStorage.setItem(SUB_NAV_COLLAPSED_STORAGE_KEY, collapsed ? '1' : '0')
  } catch {
    /* private mode */
  }
}

/**
 * 二级菜单 icon 轨收起态。
 * cookie 保证 SSR/刷新一致；sessionStorage 作迁移兜底。
 * 切勿在每次 composable 调用时重复读 storage / 重复 watch。
 */
export function useDashboardSubNavCollapsed() {
  const subNavCookie = useCookie(SUB_NAV_COLLAPSED_COOKIE, {
    default: () => '',
    ...SIDEBAR_COOKIE_OPTIONS,
    watch: true,
  })

  const ssrFlag = parseCollapsedFlag(subNavCookie.value)
  const subNavCollapsed = useState(SUB_NAV_STATE_KEY, () => ssrFlag === true)

  if (import.meta.client && !clientSyncInstalled) {
    clientSyncInstalled = true

    const resolved =
      readDocumentCookieCollapsed() ??
      readSessionCollapsed() ??
      parseCollapsedFlag(subNavCookie.value)

    if (resolved != null && subNavCollapsed.value !== resolved) {
      subNavCollapsed.value = resolved
    }
    if (resolved != null) {
      subNavCookie.value = resolved ? '1' : '0'
      writeSessionCollapsed(resolved)
    }

    watch(subNavCollapsed, (collapsed) => {
      const attr = collapsed ? '1' : '0'
      if (subNavCookie.value !== attr) subNavCookie.value = attr
      writeSessionCollapsed(collapsed)
    })
  }

  function toggleSubNav() {
    subNavCollapsed.value = !subNavCollapsed.value
  }

  return { subNavCollapsed, toggleSubNav }
}
